/**
 *  @class
 *  @function LayeredImages
 */

if (!customElements.get('layered-images')) {
 	class LayeredImages extends HTMLElement {
	  constructor() {
			super();
	  }
		connectedCallback() {
			this._scrollTriggers = [];
			if ( document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
				this.prepareAnimations();
			}
		}
		disconnectedCallback() {
			this._scrollTriggers.forEach(st => st.kill());
			this._scrollTriggers = [];
		}
		prepareAnimations() {
			let section = this.closest('.shopify-section'),
					image_1 = section.querySelector('.layered-image-1'),
					image_2 = section.querySelector('.layered-image-2'),
					image_3 = section.querySelector('.layered-image-3');

			let property = () => {
		  	return gsap.getProperty("html", "--header-height", "px");
			};
			[[image_1, '-8%'], [image_2, '30%'], [image_3, '-30%']].forEach(([el, yVal]) => {
				if (!el) return;
				const tween = gsap.to(el, {
					y: yVal,
					ease: "power1.out",
					scrollTrigger: {
						trigger: this,
						scrub: 1,
						start: () => `top 90%`,
						end: () => `bottom top+=${property()}`
					}
				});
				this._scrollTriggers.push(tween.scrollTrigger);
			});

		}
	}
	customElements.define('layered-images', LayeredImages);
}
